import { CostAdjustmentModel } from "./cost-adjustment.model";

export class CostAdjustmentDetailModel {
    costAdjustmentDetailId: number = 0;
    costAdjustmentId: number = 0;
    costAdjustment: CostAdjustmentModel | null = null;
    articleId: number = 0;
    adjustedUnitCost: number = 0;
    quantity: number = 0;
    totalValue: number = 0;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}
